<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Notification Settings</li>
    </ol>
  </nav>
  <div class="row mb-5">
    <div class="col">
      <div class="inner-box mt-3" *ngFor="let notification of notificationsList">
        <table class="table">
          <thead>
          <tr>
            <th width="50%">{{notification.groupName}}</th>
            <th width="25%">Notification Mode</th>
            <th width="25%" class="text-center">Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let n of notification?.notificationTypes">
            <td width="50%">{{n?.typeName}}</td>
            <td width="25%"><select class="form-control" id="notification" [(ngModel)]="n.notificationMode"
                                    (change)="updateStatus(n,notification.id)" [ngModelOptions]="{standalone: true}"
                                    [ngModelOptions]="{standalone: true}" required>
              <option value="Email">Email</option>
              <option value="Email_SMS">Email/SMS</option>
            </select></td>
            <td width="25%" class="text-center">
              <div class="toggle-2 custom-control custom-switch" style="padding-left: 42% !important;">
                <input type="checkbox" name="onoffswitch" class="custom-control-input" [ngModel]="n.enabled"
                       id="{{n.typeName}}" class="custom-control-input" (change)="changeStatus(n,notification.id)"
                       class="checkbox"/>
                <label class="custom-control-label" for="{{n.typeName}}" class="toggle">
                  <span>ON</span><span>OFF</span>
                </label>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
